module.exports = __webpack_public_path__ + "static/SONO-9001-6771612f387ffc094040b6d5f89a77c4.jpg";